/**
 * Utility to fix malformed Firebase Storage URLs
 * Handles partial URLs like "studs%2FIMG_0675.jpg?alt=media"
 */

const STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'magnolia-mold.firebasestorage.app';

export function resolvePhotoUrl(photoUrl) {
  // If no photoUrl, return empty string
  if (!photoUrl) return '';
  
  // If already a proper Firebase Storage URL, return as is
  if (photoUrl.includes('firebasestorage.googleapis.com') && photoUrl.includes('alt=media')) {
    return photoUrl;
  }
  
  // Handle partial Firebase Storage URLs (e.g., "studs%2FIMG_0675.jpg?alt=media")
  // These are missing the base domain
  if (photoUrl.includes('%2F') || (photoUrl.includes('.jpg') || photoUrl.includes('.png') || photoUrl.includes('.webp'))) {
    // If it looks like a partial storage path, prepend the full Firebase Storage URL
    const cleanPath = photoUrl.split('?')[0]; // Remove query params if any
    const encodedPath = encodeURIComponent(cleanPath.includes('%2F') ? decodeURIComponent(cleanPath) : cleanPath);
    return `https://firebasestorage.googleapis.com/v0/b/${STORAGE_BUCKET}/o/${encodedPath}?alt=media`;
  }
  
  // Return original if we can't resolve it
  return photoUrl;
}
